import classNames from "classnames"

interface IconButtonProps {
  disabled?: boolean
  onClick?: () => void
  children: any
}
export function IconButton(props: IconButtonProps) {
  const {disabled, onClick, children} = props;
  const handleClick = () => {
    if (disabled) return;
    onClick?.()
  }
  return <div onClick={handleClick} className={classNames(disabled && 'icon-button-disabled')}>{children}</div>
}